import {cn} from '@bem-react/classname';

export const cnPromoPageHeader = cn('PromoPageHeader');
